.form {
  margin-top: 20px;
  width: 100%;
}

.header {
  padding: 1rem 1rem 0.5rem 1rem;
}

.inputGroup {
  display: grid;
  grid-template-columns: 1fr minmax(0, 2fr);
  margin: 20px 0;
  align-items: center;
}

.productTitle {
  font-size: var(--fs-normal);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.invalidText {
  color: var(--sentiment-text-negative);
  width: 100%;
  text-align: right;
  display: inline-block;
}

.conditionNotesLabel {
  margin-bottom: 10px;
}

.addItemErrorAlert {
  margin-bottom: 20px;
}

.listPriceHelpText {
  width: 100%;
  text-align: right;
  display: inline-block;
}

.title {
  width: 100%;
  align-items: center;
}

.counter {
  padding: 0 6px;
  border-radius: 1000px;
  background: var(--sentiment-background-neutral, rgba(0, 0, 0, 0.08));
}

.section {
  padding: 1.5rem;
  border-bottom: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.dropdownContent {
  width: 100%;
  margin-right: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
}

.modal {
  max-width: 1000px;
  width: 100%;
}

.modalBody {
  padding: 0.5rem 1rem 1rem 1rem ;
  max-height: 75vh;
  overflow-y: auto;
}
